<template>
  <div class="home data-panel-home">
    <Header title="兑换记录"></Header>
    <!-- <el-alert
      :title="title"
      type="error">
    </el-alert> -->
    <el-alert
      title="由于京东服务商城停止运营，后续将不再支持京东卡兑换，您可选择提现支付渠道或对公打款"
      type="warning"
      description="已兑换过的JD卡请在下方兑换记录中点击 查看卡密 获取。复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。"
      show-icon
      :closable="false">
    </el-alert>
    <div class="selectInput">
      <div class="left-wrap">选择查询账号：</div>
      <el-select class="commit_channel" v-model="selectEmail" placeholder="请选择"  @change="changeSelectEmail">
        <el-option
        v-for="item in emailList"
        :key="item"
        :label="item"
        :value="item">
        </el-option>
      </el-select>
    </div>      
    <div class="wechat-revenue-info">
      <el-table
        v-if="exchangeList !== 'NONE'"
        :data="exchangeList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="time"
          label="发起时间"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeJDMoney"
          label="兑换JD卡总额"
          align='center'
        >
          <template slot-scope="scope">
            <div>{{scope.row.exchangeJDMoney}} 元</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="JDCardMoney"
          label="面额"
          align='center'
        >
          <template slot-scope="scope">
            <div>{{scope.row.JDCardMoney}} 元</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="JDCardCount"
          label="张数"
          align='center'
        >
        </el-table-column>
        <el-table-column
          label="兑换状态"
          align='center'
        >
          <template slot-scope="scope">
            <div v-if="scope.row.exchangeStatus == 1">兑换中</div>
            <div
              class="bonus-color bonus-cursor"
              v-if="scope.row.exchangeStatus == 2"
              @click="showJDPassAuth(scope.row.id)"
            >查看卡密</div>
            <div v-if="scope.row.exchangeStatus == 3">兑换失败，已退还BP，请查收</div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="exchangeList === 'NONE'"
        empty-text="暂无兑换记录"
      ></el-table>
      <el-dialog
        title="查看卡密"
        :visible.sync="showJDPassAuthDialog"
        width="80%"
        center
      >
      <div>
       <el-col>
          <el-row :span="3" style="margin-bottom: 10px;">人机验证:</el-row>
          <el-row :span="7">
            <vue-recaptcha
              class="captcha-wrap"
              ref="recaptcha"
              @verify="onVerify"
              @expired="onExpired"
              data-size="normal"
              :sitekey="sitekey"
            />
          </el-row>
        </el-col>
        <el-col style="margin-top: 15px;">
          <el-row :span="3">验证码:</el-row>
          <el-row :span="7">
            <SendEmailCode
              type="text"
              imageStyle="unbind-style"
              :response="response"
              class="unbind-input password-email"
              v-model="inputEmailCode"
              needImageCode=true
              :email="email"
              @emailCodeTip="emailCodeTip"
              :tel="selectTel"
            ></SendEmailCode>
          </el-row>
        </el-col>
      </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <div
            class="sure-unbind button"
            @click="showJDPassAuthDialog = false"
          >取消</div>
          <div
            class="sure-unbind button"
            type="primary"
            @click="showJDPass"
          >确定</div>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <div style="text-align: right; margin-top: 15px">
        <el-pagination 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage"
        :page-size="pagesize" 
        layout="total, prev, pager, next " 
        :total="exchangeList.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import VueRecaptcha from "vue-recaptcha";
import { LANG, SITEKEY } from "../../config/contant.js";
import SendEmailCode from "@/components/SendEmailCode.vue";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { Message } from "element-ui";
import { getCookie } from "@/utils/utils";

export default {
  name: "home",
  components: {
    Header,
    VueRecaptcha,
    SendEmailCode
  },
  data() {
    return {
      emailList:[],
      currentPage:1,
      pagesize:10,
      selectTel:'',
      selectEmail:'',
      selectId:'',
      showJDPassAuthDialog: false,
      response: "",
      sitekey: SITEKEY["LOW"], //ga verify key
      inputEmailCode: "", //输入的邮件码
      dealId: "",
      title: "1.由于京东服务商城停止运营，后续将不再支持京东卡兑换，可选择提现支付渠道/对公打款。<br>2.已兑换过的JD卡请在下方兑换记录中点击 查看卡密 获取。复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。"
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails,
    email: (state) => state.account.email,
    exchangeList: (state) => state.exchange.exchangeList,
  }),
  async created() {
    try {
      let openid = getCookie("openid") || this.$route.query.openid;
      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fexchangeList";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;

      if (openid || code) {
        this.openId = openid;
        this.getWechatInfo({ openid, code }).then(res=>{
          console.log(res);
          this.emailList = res.emails;
        })
      } else {
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions([
      "getWechatInfo", //用户email
      "getWechatTelFromEmail",//用户tel
      "getExchangeList",
      "getJDOrderPass"
    ]),
    changeSelectEmail(val){
      let email = val;
      this.getWechatTelFromEmail({ email }).then(res=>{
        this.selectTel = res.tel;
        this.selectId= res.id;
        let id = this.selectId;
        this.getExchangeList({ email:email, id:id });
      })
    },
    handleSizeChange(size){
      this.pagesize = size;
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    // 查看卡密
    showJDPassAuth(id) {
      this.showJDPassAuthDialog = true;
      this.dealId = id;
    },
    showJDPass() {
      let { inputEmailCode, dealId, selectId,selectEmail,selectTel  } = this;
      
      this.getJDOrderPass({ emailVerifyCode: inputEmailCode, dealId, email: selectEmail, id:selectId, tel:selectTel }).then(
        res => {
          if (res.data && res.data.length) {
            let html = "";
            res.data.map((item, index) => {
              html += `<div> 卡密 ${index + 1}：${item.card}`;
            });
            this.$alert(html, "卡密", {
              dangerouslyUseHTMLString: true,
              width: "480px"
            });
          } else {
            Message({
              type: "error",
              message: res.message || "network error"
            });
          }
        }
      );
    },
    onVerify: function(response) {
      this.response = response;
    },
    onExpired: function() {
      Message({
        message: this.$t("captcha.expired"),
        type: "error"
      });
      this.$refs.recaptcha.reset();
    },
    // email错误提示
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message
        });
      }
    }
 }
};
</script>
<style>
  .is-mobile .el-dialog--center{
    width:90% !important;
    margin: 15vh auto !important;
  }
  .rc-anchor-normal{
    width: 250px !important;
  }
</style>

